/*
  We're disabling ESLint's react/prop-types rule in this file because it can
  give false positives when used with TypeScript. This rule checks that all props
  used in the component are validated with PropTypes. However, in TypeScript,
  we're already type-checking our props using interfaces or types, which
  provides a level of safety that's at least as good, and typically better,
  than what PropTypes provides. Moreover, PropTypes doesn't support some
  TypeScript constructs like enum, which can lead to unnecessary errors.
  Therefore, we turn off this rule for this file.
*/
/* eslint-disable react/prop-types */

import dayjs, { type Dayjs } from "dayjs"
import { DateRangePicker } from "../DateRangePicker"

interface RenderCalendarProps {
  headerDateRange: [dayjs.Dayjs | null, dayjs.Dayjs | null]
  setReportDateRange: React.Dispatch<React.SetStateAction<[dayjs.Dayjs | null, dayjs.Dayjs | null]>>
  disabled?: boolean
}

export const RenderCalendar: React.FC<RenderCalendarProps> = ({
  headerDateRange,
  setReportDateRange,
  disabled = false,
}) => {
  const from = headerDateRange[0] ?? dayjs()
  const to = headerDateRange[1] ?? dayjs()

  return (
    <DateRangePicker
      disabled={disabled}
      value={[from, to]}
      onChange={(dates: Array<Dayjs | null> | null) => {
        setReportDateRange(dates as [Dayjs | null, Dayjs | null])
      }}
    />
  )
}
